import InputTab from './InputTab';

export default InputTab;
